module.exports = __webpack_public_path__ + "static/media/twitter.63e540d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/socials/twitter.svg
// module id = 209
// module chunks = 0